export const CRUD_PATH = `expressInspection`

export const CRUD_PATH_PLURAL = `expressInspections`
